export const FOLDER = {
  GENERAL: "general",
  BANNER: "banner",
  CHOICE: "choice",
  CORRECTION: "correction",
  QUESTION: "question",
}
